/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import IFabricantes from 'Infotrack@Modelos/smartStock/fabricantes/entidades/fabricantes';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import {
    manejadorIndicadorCargaGlobal,
    manejadorDialogoGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FabricantesCM from '../controladorModelo/fabricantesCM';
import { acciones, IEstadoFabricantes } from '../reductorFabricantes';
import FabricantesVista from '../vista/tablaFabricantesVista';
import Texto from '@infotrack/presentacion-componentes/texto';
import { useSelector } from 'react-redux';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';

const fabricantesCM = new FabricantesCM();

const TableFabricantesCV: React.FunctionComponent = () => {
    const cargaInicial = React.useRef(true);
    const [fabricantess, setFabricantess] = React.useState<IFabricantes[]>([]);
    const [{ recargarTabla }, dispatch] = useProveedor<IEstadoFabricantes>();
    const idEmpresa = useSelector((e: IEstadoGlobal) => e.estadoAutenticacion.usuarioInformacion!.IdEmpresa);
    React.useEffect(() => {
        if (recargarTabla || cargaInicial.current) {
            cargarFabricantes();
            if (recargarTabla) {
                dispatch({ type: acciones.RECARGAR_TABLA });
            }
        }
        cargaInicial.current = false;
    });

    const cargarFabricantes = () => {
        manejadorIndicadorCargaGlobal(true);
        fabricantesCM.consultarFabricantesPorFiltro({EmpresaId:idEmpresa}).then((fabricantess) => {
            setFabricantess(fabricantess);
            manejadorIndicadorCargaGlobal(false);
        });
    };
    const manejarFormulario = (tipoFormulario: TipoFormulario, entidadFabricantes?: IFabricantes) => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: { entidadFabricantes, tipoFormulario } });
    };

    const confirmarEliminacion = (fabricantes: IFabricantes) => {
        manejadorDialogoGlobal({
            accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
            accionConfirmar: () => eliminarFabricantes(fabricantes),
            estado: true,
            mensaje: <Texto id={'alerta.confirmacionEliminacion'} />,
            mostrarCancelar: true,
            tipoDialogo: 'Advertencia',
            titulo: <Texto id="titulo.advertencia" />,
        });
    };

    const eliminarFabricantes = (fabricantes: IFabricantes) => {
        manejadorIndicadorCargaGlobal(true);
        manejadorDialogoGlobal({ estado: false });
        fabricantesCM.eliminarFabricantes(fabricantes).then(() => {
            manejadorIndicadorCargaGlobal(false);
            dispatch({ type: acciones.RECARGAR_TABLA });
        });
    };

    return (
        <FabricantesVista
            fabricantess={fabricantess}
            cargarFabricantes={cargarFabricantes}
            confirmarEliminacion={confirmarEliminacion}
            manejarFormulario={manejarFormulario}
        />
    );
};

export default TableFabricantesCV;
